import { jsx } from 'panel';
import { Placement } from 'common/components/tooltip/types';
import { ButtonEl } from 'common/components/button';
import { SpinnerEl } from 'common/components/spinner';
import { SvgIconEl } from 'common/components/svg-icon';
import { TooltipEl } from 'common/components/tooltip';
import { ButtonTheme, ButtonType } from '../button/constants';
export function template() {
  const {
    helpers
  } = this;
  const icon = this.attr("icon");
  const iconEl = icon ? jsx(SvgIconEl, {
    attrs: {
      icon
    }
  }) : "";
  const uploadButton = jsx("label", null, jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Tertiary,
      icon,
      tabindex: 0,
      disabled: this.attr("disabled")
    },
    hook: {
      insert: helpers.uploadButtonInserted,
      destroy: helpers.uploadButtonDestroyed
    }
  }, this.attr("label"), jsx("input", {
    sel: '.upload-block-input',
    attrs: {
      type: "file",
      accept: this.attr("accept"),
      disabled: this.attr("disabled")
    },
    on: {
      change: helpers.handleChange
    }
  })));
  const processing = jsx("div", {
    sel: '.upload-processing'
  }, jsx(SpinnerEl, null), " ", this.attr("processing-description"));
  const complete = jsx("div", {
    sel: '.upload-complete'
  }, jsx("div", {
    sel: '.filename',
    class: {
      'is-disabled': this.attr("disabled")
    }
  }, iconEl, helpers.getFileLabel(), helpers.getFileTooltip() ? jsx(TooltipEl, {
    attrs: {
      placement: Placement.Bottom,
      offset: 0,
      delay: 200
    }
  }, helpers.getFileTooltip()) : null), this.attr("enable-delete") ? jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Tertiary,
      type: ButtonType.Destructive,
      icon: "trashcan",
      tabindex: 0,
      disabled: this.attr("disabled")
    },
    on: {
      click: helpers.handleDelete
    },
    hook: {
      insert: helpers.deleteButtonInserted,
      destroy: helpers.deleteButtonDestroyed
    }
  }) : null);
  const shown = this.attr("completed-filename") ? complete : this.attr("processing-description") ? processing : uploadButton;
  return jsx("div", {
    sel: '.file-upload-block'
  }, shown);
}